module.exports = __webpack_public_path__ + "img/purpose-2.8cfbd238.svg";